// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2c28f8a3","371":"9306424f","455":"ff45f512"}[chunkId] + ".chunk.js";
};